import React from 'react';
import { Description, Link, PopupContent } from './Terms.style';

const showPopup = ev => {
  ev.preventDefault();
  document.querySelector('.b-popup.popup').classList.add('popup--show');
  document.body.classList.add('g-lockscroll');
};

const closePopup = ev => {
  const targetClass = ev.target.classList.value;
  const closeable = ['b-popup__close-svg', 'b-popup popup popup--show'];
  if (closeable.indexOf(targetClass) > -1) {
    document.querySelector('.b-popup.popup').classList.remove('popup--show');
    document.body.classList.remove('g-lockscroll');
  }
};

const Terms = () => (
  <React.Fragment>
    <Description>
      Нажимая на&nbsp;кнопку &laquo;Далее&raquo;, я&nbsp;соглашаюсь с&nbsp;
      <Link onClick={showPopup}>
        условиями&nbsp;обработки&nbsp;персональных&nbsp;данных
      </Link>
    </Description>
    <div className="b-popup popup" onClick={closePopup}>
      <div className="b-popup__content">
        <span className="b-popup__close-svg" />
        <div className="b-popup__container">
          <div className="title-block container--m">
            <div className="b-popup__text container--m">
              <h1 className="b-popup__title">
                Я соглашаюсь с условиями обработки персональных данных
              </h1>
              <div className="disclaimer-body">
                <div className="foldable">
                  <PopupContent className="hide-foldable">
                    <p>
                      Клиент, сведения о котором (ФИО, паспортные данные,
                      сведения об адресе) содержатся в представленных в Банк
                      документах, дает свое согласие на обработку АО
                      «Райффайзенбанк», 129090, г. Москва, ул. Троицкая, д.17,
                      стр.1 (включая получение от Клиента и/или от любых третьих
                      лиц) персональных данных Клиента и подтверждает, что,
                      давая такое согласие, действует своей волей и своем
                      интересе.
                    </p>
                    <p>
                      Согласие дается Клиентом для целей заключения с Банком
                      любых договоров и их дальнейшего исполнения, оказания
                      Банком услуг, участия в проводимых Банком акциях, опросах,
                      исследованиях (включая, но не ограничиваясь проведением
                      опросов, исследований посредством электронной, телефонной
                      и сотовой связи), принятия решений или совершения иных
                      действий, порождающих юридические последствия в отношении
                      Клиента или других лиц, предоставления Клиенту информации
                      об оказываемых Банком услугах, предоставления Банком
                      консультационных услуг, в том числе в целях заключения
                      Клиентом в дальнейшем договоров/соглашений с иными лицами,
                      и распространяется на следующую информацию: фамилия, имя,
                      отчество, год, месяц, дата и место рождения, адрес,
                      реквизиты документа, удостоверяющего личность, семейное,
                      социальное, имущественное положение, образование,
                      профессия, доходы, сведения об исполнительном производстве
                      в отношении Клиента и любую иную информацию, относящуюся к
                      личности Клиента (далее — «Персональные данные»).
                    </p>
                    <p>
                      Обработка Персональных данных Клиента осуществляется
                      Банком в объеме, который необходим для достижения каждой
                      из вышеперечисленных целей. Клиент подтверждает, что
                      данное согласие действует в течение срока хранения
                      документов и сведений, содержащих персональные данные,
                      установленных действующим законодательством РФ и
                      договорами, заключенными с Клиентом.
                    </p>
                    <p>
                      Клиент вправе отозвать свое согласие путем направления
                      соответствующего письменного уведомления Банку не менее
                      чем за 3 (три) месяца до момента отзыва согласия. В случае
                      отзыва согласия Клиента на обработку Персональных данных,
                      Банк вправе не прекращать обработку Персональных данных и
                      не уничтожить их в случаях, предусмотренных
                      законодательством РФ, в том числе, если сроки хранения
                      Персональных данных не истекли.
                    </p>
                    <p>
                      Настоящее согласие предоставляется на осуществление любых
                      действий или совокупности действий с использованием
                      средств автоматизации или без использования таких средств
                      в отношении Персональных данных, которые необходимы или
                      желаемы для достижения каждой из указанных выше целей,
                      включая, без ограничения: сбор, запись, систематизацию,
                      накопление, хранение, уточнение (обновление, изменение),
                      извлечение, использование, передачу (распространение,
                      предоставление, доступ), обезличивание, блокирование,
                      удаление, уничтожение, трансграничную передачу
                      Персональных данных, получение изображения путем
                      фотографирования, а также осуществление любых иных
                      действий с Персональными данными Клиента с учетом
                      действующего законодательства.
                    </p>
                    <p>
                      Обработка Персональных данных осуществляется Банком с
                      применением следующих основных способов (но, не
                      ограничиваясь ими): хранение, запись на электронные
                      носители и их хранение, составление перечней, маркировка.
                      Клиент признает и подтверждает, что в случае необходимости
                      Банк имеет право поручить обработку Персональных данных, а
                      также передать Персональные данные для достижения
                      указанных выше целей, для целей архивного хранения, для
                      целей взыскания задолженности третьему лицу (том числе ООО
                      «ОСГ Рекордз Менеджмент», 127083, Россия, Москва, ул. 8
                      Марта, д. 14, стр.1, АО «Страховая компания МетЛайф»,
                      127015, г. Москва, ул. Бутырская, д.76, стр.1, ПАО
                      «МегаФон», 115035, Москва, Кадашевская набережная, д.30,
                      ООО «Телеконтакт», 142191, г. Москва, Орликов пер., дом 3
                      корпус «В», ООО «СК «Райффайзен Лайф», 115230, г. Москва,
                      1-й Нагатинский проезд, д.10, стр.1, АО «Либерти
                      Страхование», 196084, г. Санкт-Петербург, Московский пр.
                      д. 79А, лит. А, СПАО «РЕСО-Гарантия», 117105, г. Москва,
                      Нагорный проезд, д.6, АО «Интач Страхование», 127018, г.
                      Москва, ул. Сущевский Вал, д.18, ОАО «АльфаСтрахование»,
                      115162, Москва, ул. Шаболовка, д.31, стр. Б, ООО «Группа
                      Ренессанс Страхование», 115114, Москва, Дербеневская наб.,
                      7 стр. 22, ООО СК «ВТБ Страхование», 101000, г. Москва,
                      Чистопрудный бульвар, д.8, стр.1, АО «ЕРВ Туристическое
                      Страхование», 119049, Москва, 4-й Добрынинский пер, д.8
                      офис С 14-01, ООО «Медлэйбл» (AP Companies), 117152, г
                      Москва, Загородное шоссе, д.1, корп.1, ООО «Филберт»,
                      198095 г. Санкт-Петербург, ул. Маршала Говорова, д.35 к.5
                      лит. Ж, ООО «Эверест», 109147, г. Москва, ул.
                      Марксистская, д.34 к.8 пом.2, АО «Финансовое агентство по
                      сбору платежей», 109044, г. Москва, ул. Крутицкий Вал, д.
                      14, ООО «Бюро кредитной безопасности «Руссколлектор»,
                      129515, г. Москва, ул. Академика Королева, д.13, стр.1, АО
                      «Секвойя кредит консолидейшн», 127473, г. Москва, ул.
                      Краснопролетарская, д.16, стр.2, ООО «Столичное АВД»,
                      107564, г. Москва, ул. Краснобогатырская, д.2 стр.2 пом.5,
                      ООО «Кредитэкспресс финанс», 127055, г. Москва, ул.
                      Бутырский вал, д. 68/70 стр.1, ООО «М.Б.А. Финансы»,
                      115191, г. Москва, пер. Б. Староданиловский, д.2 стр.7
                      этаж 3, ООО «Агентство судебного взыскания», 194100, г.
                      Санкт-Петербург, просп. Лесной, д. 63 литера А, ООО «Трейд
                      энд Шоппер Маркетинг», 119334, г. Москва, ул. Вавилова,
                      д.3, ЗАО «Прайм клуб» город Москва, Рощинская 2-я улица,
                      4, Raiffeisen Bank International AG, 1030, Austria,
                      Vienna, Am Stadtpark 9, ООО «Аби», 127273, г. Москва, ул.
                      Отрадная, дом 2Б, строение 6, офис 12, Kofax Schweiz AG,
                      6343, Switzerland, Rotkreuz, Grundstrasse 14, ООО «Группа
                      АйБи», 115088, Москва, ул. Шарикоподшипниковская, д. 1,
                      офис ЭТ 9 К 2, АО «Лаборатория Касперского», 125212, город
                      Москва, Ленинградское шоссе, дом 39а строение 2, а также
                      иным некредитным и небанковским организациям), а равно как
                      при привлечении третьих лиц к оказанию услуг, передачи
                      Банком принадлежащих ему функций и полномочий иному лицу
                      (уступке, в том числе для рассмотрения возможности уступки
                      и принятию решения об уступке, залогу, принадлежащих Банку
                      прав и др.).
                    </p>
                    <p>
                      Я понимаю и соглашаюсь с тем, что, поставив отметку: я
                      выражаю свое согласие МегаФон (ПАО «МегаФон», Москва,
                      Кадашевская набережная, д.30) (далее – Оператор связи) на
                      предоставление им АО «Райффайзенбанк» (129090, г. Москва,
                      ул. Троицкая, д. 17, стр.1), сведений обо мне как
                      абоненте* и оказываемых мне услугах связи по договору об
                      оказании услуг связи, заключенному с таким оператором
                      связи.
                    </p>
                    <p>
                      * - к сведениям об абоненте относятся адрес абонента,
                      абонентские номера и другие данные, позволяющие
                      идентифицировать абонента или его пользовательское
                      устройство, сведения баз данных систем расчета за
                      оказанные услуги связи, в том числе о трафике и платежах
                      абонента.
                    </p>
                  </PopupContent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Terms;
